var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "ImageUploadView",
      class: {
        ..._vm.modes.map((m) => `ImageUploadView--${m}`),
        "ImageUploadView--withRemove": _vm.showRemove,
        "u-ErrorView": _vm.hasError,
        "ImageUploadView--error": _vm.isError,
        isLoader: _vm.isLoader,
      },
    },
    [
      _vm.title
        ? _c("div", { staticClass: "ImageUploadViewCaption" }, [
            _vm._v("\n\t\t" + _vm._s(_vm.title) + "\n\t"),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "ImageUploadViewInner",
          style: _vm.innerStyles,
          on: {
            dragover: function ($event) {
              $event.preventDefault()
            },
            drop: _vm.onDrop,
          },
        },
        [
          _c(
            "label",
            { staticClass: "FullEditView ImageUploadViewLabel" },
            [
              _c("div", { staticClass: "ImageUploadViewLabelContent" }, [
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isLoader,
                        expression: "!isLoader",
                      },
                    ],
                    staticClass: "ImageUploadViewLabelText",
                  },
                  [_vm._t("default")],
                  2
                ),
                _vm._v(" "),
                _c("input", {
                  staticClass: "ImageUploadViewInput",
                  attrs: { type: "file", name: "file" },
                  on: { change: _vm.onSelect },
                }),
              ]),
              _vm._v(" "),
              _vm.hasEdit
                ? _vm._t("edit", function () {
                    return [_c("edit-view")]
                  })
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "ImageUploadViewPreview",
            style: {
              backgroundSize: _vm.objectFit,
              backgroundImage: _vm.imgUrl && `url(${_vm.imgUrl})`,
            },
            attrs: { alt: "" },
          }),
          _vm._v(" "),
          _vm._t("overlay"),
          _vm._v(" "),
          _vm.showRemove
            ? _vm._t("remove", function () {
                return [_c("remove-view", { on: { click: _vm.onRemove } })]
              })
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }